export enum PaymentMethodChangeContextEnum {
  ADD_NEW = 'ADD_NEW',
  CHANGE_ENROLLMENT_PAYMENT_METHOD = 'CHANGE_ENROLLMENT_PAYMENT_METHOD',
  CHANGE_ORDER_PAYMENT_METHOD = 'CHANGE_ORDER_PAYMENT_METHOD',
}
